import http from './http'

export default {
    prospects() {
        return http.get('sadasi/prospects')
    },

    create(prospecto) {
        return http.post('sadasi/prospects', prospecto);
    },

    addComment(prospecto, contenido) {
        return http.post(`sadasi/prospects/${prospecto}/comentarios`, {
            contenido
        })
    },
}